import React from 'react';
import { Avatar as MuiAvatar, Tooltip } from '@mui/material';
import { Avatar } from '../../services/userService';
import { getDefaultAvatar } from '../../utils/avatarConfig';

interface AvatarDisplayProps {
  avatar?: Avatar;
  name: string;
  role?: 'student' | 'teacher';
  size?: 'small' | 'medium' | 'large';
  showTooltip?: boolean;
}

/**
 * AvatarDisplay component
 * Displays a user's avatar with emoji and color background
 */
const AvatarDisplay: React.FC<AvatarDisplayProps> = ({
  avatar,
  name,
  role = 'student',
  size = 'medium',
  showTooltip = true,
}) => {
  // Use provided avatar or default based on role
  const displayAvatar = avatar || getDefaultAvatar(role);

  // Size mapping
  const sizeMap = {
    small: { width: 32, height: 32, fontSize: '1rem' },
    medium: { width: 40, height: 40, fontSize: '1.25rem' },
    large: { width: 56, height: 56, fontSize: '1.75rem' },
  };

  const avatarStyle = {
    ...sizeMap[size],
    backgroundColor: displayAvatar.color,
    color: '#fff',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  };

  const avatarElement = <MuiAvatar sx={avatarStyle}>{displayAvatar.emoji}</MuiAvatar>;

  if (showTooltip) {
    return (
      <Tooltip title={name} arrow>
        {avatarElement}
      </Tooltip>
    );
  }

  return avatarElement;
};

export default AvatarDisplay;
